import React, { useState, useEffect } from "react";
import Header from "../Header/Header";
import Asidebar from "../Header/Asidebar";
import { Link } from "react-router-dom";
import { getData, deleteData } from "../../FetchNodeServices";
import { InfinitySpin } from "react-loader-spinner";

const ManageProfilingQuestions = () => {
  const [isActivated, setIsActivated] = useState(true);
  const [fullwidthwrapper, setfullwidthwrapper] = useState();
  const [questionList, setQuestionList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");

  const handleToggle = () => {
    setIsActivated(!isActivated);
    setfullwidthwrapper(isActivated ? "fullwrapper" : "");
  };

  const handleDeleteQuestion = async (questionId) => {
    let result = await deleteData("users/question/" + questionId);
    fetchQuestions();
    if (result) {
      console.log("Question Deleted");
    } else {
      console.log("error in deletion of question");
    }
  };

  const fetchQuestions = async () => {
    let result = await getData("users/question-list");
    setQuestionList(result);
    setIsLoading(false);
  };
  useEffect(
    function () {
      if (searchTerm.trim() === "") {
        fetchQuestions();
      }
    },
    [searchTerm]
  );

  const fillQuestions = () => {
    // const sortedQuestions = questionList.sort((a, b) => b.questionId - a.questionId);

    return questionList.map((item) => {
      return (
        <tr key={item.questionId}>
          <td>{item.questionId}</td>
          <td>{item.questionCode}</td>
          <td>{item.question}</td>
          <td>{item.queType}</td>
          <td>
            <Link to={`/edit-questions?questionId=${item.questionId}`}>
              <i className="bi bi-eye mx-1 fs-20"></i>
            </Link>
            <i className="bi bi-trash fs-20" onClick={() => handleDeleteQuestion(item.questionId)}></i>
          </td>
        </tr>
      );
    });
  };

  //    const handleSearch = async () => {
  //   let result = await getData("users/question" + questionId);
  //   setCustomerList(result);
  //   setIsLoading(false);
  // };

  const handleSearch = async () => {
    setIsLoading(true);
    let result = await getData("users/question-list?search=" + searchTerm);
    setQuestionList(result);
    setIsLoading(false);
  };

  return (
    <div>
      <Asidebar isActivated={isActivated} />
      <div id="wrapper" className={fullwidthwrapper}>
        <Header onclick={handleToggle} />
        <div id="page_wrapper" className="py-3">
          <div className="card p-3 border-light-subtle mb-3">
            <ul className="breadcrumb m-0">
              <li>
                <Link to="/dashboard">
                  <i className="bi bi-people"></i> Dashboard
                </Link>
              </li>
              <li>
                <span className="breadcrumb_slash">/</span>
                <i className="bi bi-people"></i> Profiling
              </li>
              <li>
                <span className="breadcrumb_slash">/</span> <i className="bi bi-app-indicator mx-2"></i> Manage Profiling Questions
              </li>
            </ul>
          </div>

          <div className="card p-3 border-light-subtle">
            <div className="filter_header fs-12 lh-14">
              <div className="row">
                <div className="col-lg-6">
                  <div className="d-flex gap-1 ">
                    <div className="search_box">
                      <input type="text" value={searchTerm} className="w-100 form-control" onChange={(event) => setSearchTerm(event.target.value)} />
                    </div>
                    <div className="search_button">
                      <button className="btn btn-outline-light border text-dark py-0 fs-12 fw-600" onClick={() => handleSearch()}>
                        <i className="bi bi-search me-1"></i>Search
                      </button>
                    </div>
                  </div>
                </div>
                {/* <div className="col-lg-3 d-flex align-items-center">
                  <div className="mt-4 mt-lg-0">
                    <label htmlFor="" className=" fs-15">
                      Advance Search
                    </label>
                  </div>
                </div> */}
                <div className="col-lg-6 d-flex justify-content-end">
                  <div className="mt-3 mt-lg-0">
                    <Link to="/profiling-questions">
                      <button className="btn btn-success   py-0 fs-12 fw-600">
                        <i className="bi bi-plus fs-15"></i> Add a question
                      </button>
                    </Link>
                  </div>
                </div>
              </div>
            </div>

            <div className="table-responsive mt-3">
              <table className="table fs-14 lh-20 text-center">
                <thead className="table-light  fs-12 lh-16  border-top">
                  <tr>
                    {/* <th>Question Title</th>
                    <th>Question text</th>
                    <th>Question Category</th>
                    <th>Geo</th>
                    <th>Languages</th>
                    <th>Question type</th>
                    <th>Answer type</th>
                    <th>Question Visibility</th>
                    <th>Status</th> */}
                    <th>Order No.</th>
                    <th>Question Code</th>
                    <th>Question Title</th>
                    <th>Type</th>
                    <th>View/Delete</th>
                  </tr>
                </thead>
                <tbody>
                  {isLoading && (
                    <tr>
                      <td colSpan={8} className="text-center">
                        <InfinitySpin visible={true} width="200" color="#4fa94d" ariaLabel="infinity-spin-loading" />
                      </td>
                    </tr>
                  )}
                  {fillQuestions()}
                  {/* <tr>
                    <td>Short</td>
                    <td>What's your favorite childhood memory?</td>
                    <td>Multi-select</td>
                    <td>21.12.0</td>
                    <td>English</td>
                    <td>Multi-select</td>
                    <td>short</td>
                    <td>visible</td>
                    <td>
                      <span className="bg-success-subtle text-teal rounded-pill px-2 py-1 fs-12">Active</span>
                    </td>
                  </tr>
                  <tr>
                    <td>Short</td>
                    <td>What's your favorite childhood memory?</td>
                    <td>Multi-select</td>
                    <td>21.12.0</td>
                    <td>English</td>
                    <td>Multi-select</td>
                    <td>short</td>
                    <td>visible</td>
                    <td>
                      <span className="bg-success-subtle text-teal rounded-pill px-2 py-1 fs-12">Active</span>
                    </td>
                  </tr>
                  <tr>
                    <td>Short</td>
                    <td>What's your favorite childhood memory?</td>
                    <td>Multi-select</td>
                    <td>21.12.0</td>
                    <td>English</td>
                    <td>Multi-select</td>
                    <td>short</td>
                    <td>visible</td>
                    <td>
                      <span className="bg-success-subtle text-teal rounded-pill px-2 py-1 fs-12">Active</span>
                    </td>
                  </tr>
                  <tr>
                    <td>Short</td>
                    <td>What's your favorite childhood memory?</td>
                    <td>Multi-select</td>
                    <td>21.12.0</td>
                    <td>English</td>
                    <td>Multi-select</td>
                    <td>short</td>
                    <td>visible</td>
                    <td>
                      <span className="bg-success-subtle text-teal rounded-pill px-2 py-1 fs-12">Active</span>
                    </td>
                  </tr>
                  <tr>
                    <td>Short</td>
                    <td>What's your favorite childhood memory?</td>
                    <td>Multi-select</td>
                    <td>21.12.0</td>
                    <td>English</td>
                    <td>Multi-select</td>
                    <td>short</td>
                    <td>visible</td>
                    <td>
                      <span className="bg-success-subtle text-teal rounded-pill px-2 py-1 fs-12">Active</span>
                    </td>
                  </tr>
                  <tr>
                    <td>Short</td>
                    <td>What's your favorite childhood memory?</td>
                    <td>Multi-select</td>
                    <td>21.12.0</td>
                    <td>English</td>
                    <td>Multi-select</td>
                    <td>short</td>
                    <td>visible</td>
                    <td>
                      <span className="bg-success-subtle text-teal rounded-pill px-2 py-1 fs-12">Active</span>
                    </td>
                  </tr> */}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ManageProfilingQuestions;
